import { Address } from '../common/address';
import { IRowVersionableDto } from '../common/rowVersionable';
import { GetTeamMemberDetailsDto } from '../tender.team.members/tender.team.member.models';

export class RegistrationFirstStepModel {
    firstName: string;
    lastName: string;
    companyName: string;
    contactNumber: string;
    address: Address;
    emailAddress: string;
    password: string;
    confirmPassword: string;
    referrerId: number;
    catId: number;
    locId: number;
    registrationPageText: string;
    gclid: string;
    tAndCsAgreed: boolean;

    constructor() {
        this.address = new Address();
    }
}

export class RegistrationCompleteModel {
    registrationToken: string;
    categoryIds: number[];
    locationIds: number[];
    sendNewsletters: boolean;
    tAndCsAgreed: boolean;
    registrationPageFooterText: string;

    constructor() {
        this.categoryIds = [];
        this.locationIds = [];
    }
}

export class CapturedAddress {
    id: string;
    text: string;
    description: string;
}

export class AddressLookupResult {
    capturedAddresses: CapturedAddress[];
    retrievedAddress: Address;
}

export class TenderTeamMemberRegistrationModel implements IRowVersionableDto {
    constructor(detailsDto: GetTeamMemberDetailsDto) {
        this.rowVersion = detailsDto.rowVersion;
        this.firstName = detailsDto.firstName;
        this.lastName = detailsDto.lastName;
        this.companyName = detailsDto.companyName;
        this.email = detailsDto.email;
        this.id = detailsDto.id;
    }

    rowVersion: string;
    firstName: string;
    lastName: string;
    companyName: string;
    id: number;
    email: string;
    password: string;
    confirmPassword: string;
    token: string;
    acceptedTermsAndConditions: boolean;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/models/registration/registration.models.ts